import {fetchPost} from "./mvjs/fetchPost";
import {basketUpdate} from "./basketUpd";
import {basketFrm} from "./basketFrm";

export const basketShipInit = () => {

    const ship1      = document.getElementById('ship1')
    const ship2      = document.getElementById('ship2')
    const ship3      = document.getElementById('ship3')
    const shipCh     = document.getElementById('shipSelect');

    if (shipCh){
        shipCh.addEventListener('choice', (e) => {
            document.getElementById('ship4').value = e.detail.choice.value;
            shipUpdate()
        })
    }

    if (ship1){
        ship1.addEventListener('click', ()=>{
            shipUpdate()
        })
    }

    if (ship2){
        ship2.addEventListener('click', ()=>{
            shipUpdate()
        })
    }


    if (ship3){
        ship3.addEventListener('click', ()=>{
            shipUpdate()
        })
    }

    function shipUpdate() {

        fetchPost('/cart/update', JSON.stringify(basketFrm()) , body => {
            if (body && body.success){
                basketUpdate(body);
            }
        });

    }
}